import Image from 'next/image'

interface LogoProps {
    logoUrl?: string
    size?: number
}

export default function Logo({ logoUrl, size = 50 }: LogoProps) {
    return (
        <Image
            src={logoUrl || '/logo.png'}
            alt='Logo'
            width={size}
            height={size}
            className={logoUrl ? 'rounded-full' : undefined}
        />
    )
}
